<template>
  <div class="performance">
    <div v-show="!isContinueText" class="performance-info">
      <div class="performance-info-title">{{ $t('lang.kh.dialog.title') }}</div>
      <div class="performance-info-main scroll">
        <div
          class="result"
          :class="{ bigo: item.result }"
          v-for="item in data"
          :key="item.id"
        >
          <span>
            {{
              item.type === 0
                ? $t('lang.kh.dialog.singleChoice')
                : $t('lang.kh.dialog.multipleChoice')
            }}
            ({{ item.id + 1 }})
          </span>
          <div class="result-score" :class="{ 'bigo-text': item.result }">
            <span>{{
              item.result
                ? $t('lang.kh.dialog.answer_right')
                : $t('lang.kh.dialog.anser_wrong')
            }}</span>
            <span class="score">{{ item.result ? '+ 2' : '0' }}</span>
          </div>
        </div>
      </div>
      <div class="performance-info-score">
        {{ $t('lang.kh.dialog.score') + score + $t('lang.kh.dialog.Company') }}
      </div>
    </div>
    <div v-show="!isContinueText" class="performance-btn">
      <span @click="continueText"> {{ $t('lang.kh.dialog.continue') }} </span>
    </div>
    <div v-show="isContinueText" class="popconfirm">
      <img
        :src="this.publicData.serverUrl + 'images/tip-icons@2x.png'"
        alt=""
      />
      <span>{{ $t('lang.kh.dialog.result') }}</span>
      <div class="popconfirm-btns">
        <div class="btn" @click="goPath">{{ $t('lang.kh.dialog.start') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'score'],
  data() {
    return {
      isContinueText: false,
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    continueText() {
      this.isContinueText = true
    },
    goPath() {
      this.$router.push('/experimentation/experimentation2/InteractiveRoofTest')
    },
  },
}
</script>

<style lang="scss" scoped>
.performance {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  &-info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50vw;
    height: 70vh;
    background-image: var(--performance-bg);
    background-size: 100% 100%;
    overflow: hidden;
    &-title {
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 2%;
      margin-bottom: 2vh;
      color: white;
      font-size: 32px;
    }
    &-main {
      width: 95%;
      height: 48vh;
      padding: 0 7%;
      .result {
        display: flex;
        justify-content: space-between;
        line-height: 3;
        padding: 0 1.875vw;
        margin-bottom: 15px;
        border-left: 5px solid #888888;
        border-right: 5px solid #888888;
        border-top: 1px solid #888888;
        border-bottom: 1px solid #888888;
        &-score {
          display: flex;
          .score {
            text-align: center;
            width: 2rem;
            margin-left: 2rem;
          }
        }
      }
      .bigo {
        border-left: 5px solid var(--exp-color);
        border-right: 5px solid var(--exp-color);
        &-text {
          font-weight: bold;
          color: var(--exp-color);
        }
      }
    }
    &-score {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 6%;
      text-align: center;
      font-size: 1.875vw;
      font-weight: bold;
      color: #a63528;
    }
  }
  &-btn {
    position: absolute;
    bottom: 8vh;
    left: 50%;
    transform: translateX(-50%);
    span {
      color: white;
      padding: 15px 40px;
      background: #a63528;
      border-radius: 25px;
      cursor: pointer;
    }
  }
}
</style>